function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9998 8.00013C15.9998 4.82844 14.154 2.08795 11.478 0.793945V15.2063C14.154 13.9123 15.9998 11.1718 15.9998 8.00013Z",
  fill: "#D80027"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 8.00013C0 11.1718 1.84578 13.9123 4.52175 15.2063V0.793945C1.84578 2.08795 0 4.82844 0 8.00013Z",
  fill: "#D80027"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.39119 9.04368L10.7825 8.34802L10.0869 8.00021V7.30455L8.69554 8.00021L9.39119 6.6089H8.69554L7.99988 5.56543L7.30422 6.6089H6.60857L7.30422 8.00021L5.91291 7.30455V8.00021L5.21729 8.34802L6.60857 9.04368L6.26075 9.73933H7.65207V10.7828H8.34769V9.73933H9.73901L9.39119 9.04368Z",
  fill: "#D80027"
});
const SvgCanada = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCanada, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/canada.b79018c1.svg";
export { ForwardRef as ReactComponent };